import { render, staticRenderFns } from "./buy-again.vue?vue&type=template&id=657bb3d4"
import script from "./buy-again.vue?vue&type=script&lang=js"
export * from "./buy-again.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports